import { render, staticRenderFns } from "./NoPermissionComponent.vue?vue&type=template&id=495b0759&"
import script from "./NoPermissionComponent.vue?vue&type=script&lang=js&"
export * from "./NoPermissionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports